module.exports = __webpack_public_path__ + "img/11_74.1cf68238.png";